import { render } from "./sideMenu.vue?vue&type=template&id=630c2d71&ts=true"
import script from "./sideMenu.vue?vue&type=script&lang=ts"
export * from "./sideMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__